// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Inter';
}

.styles_main__MLvuD {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.styles_title__GaVca {
  color: #0f2047 !important;
  font-family: "Inter" !important;
  font-weight: 500 !important;
  text-align: center !important;
  font-size: 1rem !important;
}

.styles_separador__XBucw {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  width: 100%;
}

.styles_botaoProsseguir__emNou {
  background-color: #18316e !important;
  font-family: "Inter" !important;
  transition: all 0.3s ease !important;
  text-transform: none !important;
  font-weight: 300 !important;
  align-self: flex-end;
  margin-top: 2rem !important;
}

.styles_content__TmYRx {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
  box-shadow: 2px 2px 9px rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  padding: 2rem;
}

.styles_content__tipos__wl0Fs {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
}

.styles_content__motiv__1YYMQ {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.styles_textContainer__modal__xxWxo {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.styles_textContainer__modal__xxWxo span {
  font-weight: 400;
  color: #0f2047;
  font-size: 0.9rem;
  text-align: justify;
}

.styles_btnContainer__modal__GvwuI {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/pages/SelecionarTiposNegocio/styles.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;EACpC,+BAA+B;EAC/B,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,0CAA0C;EAC1C,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":["* {\n  font-family: 'Inter';\n}\n\n.main {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.title {\n  color: #0f2047 !important;\n  font-family: \"Inter\" !important;\n  font-weight: 500 !important;\n  text-align: center !important;\n  font-size: 1rem !important;\n}\n\n.separador {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.botaoProsseguir {\n  background-color: #18316e !important;\n  font-family: \"Inter\" !important;\n  transition: all 0.3s ease !important;\n  text-transform: none !important;\n  font-weight: 300 !important;\n  align-self: flex-end;\n  margin-top: 2rem !important;\n}\n\n.content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 2rem;\n  box-shadow: 2px 2px 9px rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  padding: 2rem;\n}\n\n.content__tipos {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  justify-content: center;\n  align-items: center;\n}\n\n.content__motiv {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.textContainer__modal {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.textContainer__modal span {\n  font-weight: 400;\n  color: #0f2047;\n  font-size: 0.9rem;\n  text-align: justify;\n}\n\n.btnContainer__modal {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `styles_main__MLvuD`,
	"title": `styles_title__GaVca`,
	"separador": `styles_separador__XBucw`,
	"botaoProsseguir": `styles_botaoProsseguir__emNou`,
	"content": `styles_content__TmYRx`,
	"content__tipos": `styles_content__tipos__wl0Fs`,
	"content__motiv": `styles_content__motiv__1YYMQ`,
	"textContainer__modal": `styles_textContainer__modal__xxWxo`,
	"btnContainer__modal": `styles_btnContainer__modal__GvwuI`
};
export default ___CSS_LOADER_EXPORT___;
